import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/chat/singleChat.svg'
import _imports_1 from '../../../assets/chat/groupChat.svg'
import _imports_2 from '../../../assets/chat/noticationChat.svg'


const _withScopeId = n => (_pushScopeId("data-v-304539a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactItem" }
const _hoisted_2 = { class: "leftBox" }
const _hoisted_3 = {
  key: 0,
  class: "textBox"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "textBox"
}
const _hoisted_6 = {
  key: 0,
  src: _imports_0
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1
}
const _hoisted_8 = {
  key: 2,
  src: _imports_2
}
const _hoisted_9 = { class: "rightBox" }
const _hoisted_10 = { class: "r_top" }
const _hoisted_11 = {
  key: 0,
  class: "username wordHidden"
}
const _hoisted_12 = {
  key: 1,
  class: "username wordHidden"
}
const _hoisted_13 = {
  key: 2,
  class: "time"
}
const _hoisted_14 = {
  key: 3,
  class: "time"
}
const _hoisted_15 = { class: "lastMsg wordHidden" }

import { ref, computed } from "vue";
import { dateFormat, getFirstXLetters } from "@/utils/format";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'contactItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const store = useStore();
const isVibe = computed(() => store.state.isVibe);


const typeArr = [
  "[Picture]",
  "[Video]",
  "[Audio]",
  "[Contact Card]",
  "[Location]",
  "[Other]",
];

const filterMessage = (msg: string) => {
  const typeMap: any = {
    "[Picture]": "chat.pictureText",
    "[Video]": "chat.videoText",
    "[Audio]": "chat.audioText",
    "[Contact Card]": "chat.contactCard",
    "[Location]": "chat.location",
    "[Other]": "chat.other",
  };
  return typeMap[msg] || msg;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.item.avatar_url && !isVibe.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: __props.item.avatar_url,
              alt: "",
              class: "demoAvatar"
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (__props.item.chat_type == 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (__props.item.chat_type == 2)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8))
          ]))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (__props.item.chat_session_id == 'default_cid_')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("chat.unknownContact")), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(__props.item.title), 1)),
        (__props.item.last_time)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(dateFormat)(__props.item.last_time, "YYYY-MM-DD HH:mm") || "--"), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_14))
      ]),
      _createElementVNode("div", _hoisted_15, _toDisplayString(typeArr.includes(__props.item.last_message)
          ? _ctx.$t(filterMessage(__props.item.last_message))
          : __props.item.last_message), 1)
    ])
  ]))
}
}

})